import React from 'react';

const ErrorMessage = ({ text }) => {
    if (!text) {
        return (
            <span className="small">
                &nbsp;
            </span>
        );
    }
    return (
        <span className="text-danger small">
            {text}
        </span>
    );
};

export default ErrorMessage;


// WEBPACK FOOTER //
// ./src/components/billing-form/ErrorMessage.js